export const properWords = (str: string) => {
	return str
		.replaceAll(/[_-]/g, ' ')
		.split(' ')
		.map((word) => {
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
		})
		.join(' ')
}
